import { Stack } from '@mui/material';
import { ReactComponent as LayerLogo } from '@/assets/logos/axiom/layer.svg';
import { ReactComponent as LayerText } from '@/assets/logos/axiom/text.svg';

export const AxiomLogo = () => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      height={30}
      spacing={1}
      sx={{
        background: "linear-gradient(179deg, #1E096B 48.86%, #223DC3 99.26%)",
        padding: "8px",
      }}
      width={206}
    >
      <LayerText style={{ height: 32 }} />
      <LayerLogo style={{ height: 32 }} />
    </Stack>
  );
};
